import { render, staticRenderFns } from "./displayStyle-editor.vue?vue&type=template&id=e0557052&scoped=true&"
import script from "./displayStyle-editor.vue?vue&type=script&lang=js&"
export * from "./displayStyle-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0557052",
  null
  
)

export default component.exports